// extracted by mini-css-extract-plugin
export var closeButton = "_2a-3";
export var header = "_2a-0";
export var link = "_2a-1";
export var retryButton = "_2a-2";